import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Layout from "./pages/Layout";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";

const SD_Dashboard = React.lazy(() => import("./pages/SD/Dashboard"));
const SD_OPAll = React.lazy(() => import("./pages/SD/OP/AllHome"));
const SD_OPCreate = React.lazy(() => import("./pages/SD/OP/CreateHome"));
const SD_OPEdit = React.lazy(() => import("./pages/SD/OP/EditHome"));
const SD_SOTAll = React.lazy(() => import("./pages/SD/SOT/AllHome"));
const SD_SOTCreate = React.lazy(() => import("./pages/SD/SOT/CreateHome"));
const SD_SOTHistory = React.lazy(() => import("./pages/SD/SOT/HistoryHome"));
const SD_SOTCancel = React.lazy(() => import("./pages/SD/SOT/old/cancel"));
const SD_SOTSummary = React.lazy(() => import("./pages/SD/SOT/SummaryHome"));
const SD_SOTEdit = React.lazy(() => import("./pages/SD/SOT/EditHome"));
const SD_SOTappointment = React.lazy(() =>
  import("./pages/SD/SOT/AppointmentHome")
);
const SD_SOTpart_request = React.lazy(() =>
  import("./pages/SD/SOT/PartRequestHome")
);
const SD_PRAll = React.lazy(() => import("./pages/SD/PR/AllHome"));
const SD_PRhistory = React.lazy(() => import("./pages/SD/PR/HistoryHome"));
const SD_PRdetail = React.lazy(() => import("./pages/SD/PR/DetailHome"));

const SE_Dashboard = React.lazy(() => import("./pages/SE/DashboardHome"));
const SE_JFServiceType = React.lazy(() =>
  import("./pages/SE/JF/old/job_service_type")
);
const SE_JFJobAppointment = React.lazy(() =>
  import("./pages/SE/JF/AppointmentHome")
);
const SE_JFJobDetail = React.lazy(() => import("./pages/SE/JF/JobDetail"));
const SE_JFJobHistory = React.lazy(() => import("./pages/SE/JF/HistoryHome"));
const SE_JFJobStopToWork = React.lazy(() =>
  import("./pages/SE/JF/JobDetailStopToWorkForm")
);
const SE_JFJobPartUsage = React.lazy(() =>
  import("./pages/SE/JF/PartUsageHome")
);
const SE_JFJobPartRequest = React.lazy(() =>
  import("./pages/SE/JF/PartRequestHome")
);
const SE_SOTLeave = React.lazy(() =>
  import("./pages/SE/JobReportDeliveryHome")
);
const SE_PartReturn = React.lazy(() => import("./pages/SE/PartReturnHome"));
const SE_PartRequest = React.lazy(() => import("./pages/SE/PartRequest"));
const SE_PartList = React.lazy(() => import("./pages/SE/PartListHome"));
const SE_PartRequestDetail = React.lazy(() =>
  import("./pages/SE/PartRequestDetail")
);

const LOGISTIC_Dashboard = React.lazy(() =>
  import("./pages/LOGISTIC/Dashboard")
);
const LOGISTIC_PRTAll = React.lazy(() => import("./pages/LOGISTIC/PR/all"));
const LOGISTIC_PRTUnclosed = React.lazy(() =>
  import("./pages/LOGISTIC/PR/unclosed")
);
const LOGISTIC_PRTUnclosedDetail = React.lazy(() =>
  import("./pages/LOGISTIC/PR/unclosed_detail")
);
const LOGISTIC_PRTUnclosedDeliver = React.lazy(() =>
  import("./pages/LOGISTIC/PR/unclosed_deliver")
);
const LOGISTIC_PRTUnclosedHistory = React.lazy(() =>
  import("./pages/LOGISTIC/PR/unclosed_history")
);
const LOGISTIC_PRTClosed = React.lazy(() =>
  import("./pages/LOGISTIC/PR/closed")
);
const LOGISTIC_PRTPending = React.lazy(() =>
  import("./pages/LOGISTIC/PR/pending")
);
const LOGISTIC_PRTClosedDetail = React.lazy(() =>
  import("./pages/LOGISTIC/PR/closed_detail")
);
const LOGISTIC_PRTClosedHistory = React.lazy(() =>
  import("./pages/LOGISTIC/PR/closed_history")
);
const LOGISTIC_RRTAll = React.lazy(() => import("./pages/LOGISTIC/RR/all"));
const LOGISTIC_RRTCreate = React.lazy(() =>
  import("./pages/LOGISTIC/RR/create")
);
const LOGISTIC_RRTShow = React.lazy(() => import("./pages/LOGISTIC/RR/show"));
const LOGISTIC_RRTHistory = React.lazy(() =>
  import("./pages/LOGISTIC/RR/history")
);
const LOGISTIC_PART_RETURNprt = React.lazy(() =>
  import("./pages/LOGISTIC/PART_RETURN/prt")
);
const LOGISTIC_PART_RETURNrrt = React.lazy(() =>
  import("./pages/LOGISTIC/PART_RETURN/rrt")
);
const LOGISTIC_AssetAll = React.lazy(() =>
  import("./pages/LOGISTIC/ASSET/Asset")
);
const LOGISTIC_AssetCreate = React.lazy(() =>
  import("./pages/LOGISTIC/ASSET/AssetCreate")
);
const LOGISTIC_AssetDetail = React.lazy(() =>
  import("./pages/LOGISTIC/ASSET/AssetShow")
);
const LOGISTIC_AssetEdit = React.lazy(() =>
  import("./pages/LOGISTIC/ASSET/AssetEdit")
);
const LOGISTIC_AssetCondition = React.lazy(() =>
  import("./pages/LOGISTIC/ASSET/AssetCondition")
);
const LOGISTIC_AssetTransfer = React.lazy(() =>
  import("./pages/LOGISTIC/ASSET/AssetTransfer")
);
// const LOGISTIC_AssetHistory = React.lazy(() => import('./pages/LOGISTIC/ASSET/AssetHistory'))
const LOGISTIC_PartRepairableAll = React.lazy(() =>
  import("./pages/LOGISTIC/PART_REPAIRABLE/PartRepairable")
);
const LOGISTIC_PartRepairableCreate = React.lazy(() =>
  import("./pages/LOGISTIC/PART_REPAIRABLE/PartRepairableCreate")
);
const LOGISTIC_PartRepairableEdit = React.lazy(() =>
  import("./pages/LOGISTIC/PART_REPAIRABLE/PartRepairableEdit")
);
const LOGISTIC_PartRepairableShow = React.lazy(() =>
  import("./pages/LOGISTIC/PART_REPAIRABLE/PartRepairableShow")
);
const LOGISTIC_PartRepairableCondition = React.lazy(() =>
  import("./pages/LOGISTIC/PART_REPAIRABLE/PartRepairableCondition")
);
const LOGISTIC_PartRepairableTransfer = React.lazy(() =>
  import("./pages/LOGISTIC/PART_REPAIRABLE/PartRepairableTransfer")
);
const LOGISTIC_PartNonRepairableAll = React.lazy(() =>
  import("./pages/LOGISTIC/PART_NON_REPAIRABLE/PartNonRepairable")
);
const LOGISTIC_PartNonRepairableCreate = React.lazy(() =>
  import("./pages/LOGISTIC/PART_NON_REPAIRABLE/PartNonRepairableCreate")
);
const LOGISTIC_PartNonRepairableEdit = React.lazy(() =>
  import("./pages/LOGISTIC/PART_NON_REPAIRABLE/PartNonRepairableEdit")
);
const LOGISTIC_PartNonRepairableShow = React.lazy(() =>
  import("./pages/LOGISTIC/PART_NON_REPAIRABLE/PartNonRepairableShow")
);
const LOGISTIC_PartNonRepairableCondition = React.lazy(() =>
  import("./pages/LOGISTIC/PART_NON_REPAIRABLE/PartNonRepairableCondition")
);
const LOGISTIC_PartNonRepairableTransfer = React.lazy(() =>
  import("./pages/LOGISTIC/PART_NON_REPAIRABLE/PartNonRepairableTransfer")
);
// BTS0523: Stock Monitoring page
const LOGISTIC_StockMonitoring = React.lazy(() =>
  import("./pages/LOGISTIC/Stock")
);
// BTS0509/0510: Performance Analysis page
const REPORT_Performance = React.lazy(() =>
  import("./pages/REPORT/PerformanceAnalysis")
);
// BTSxxxx: Analytics Dashboard
const SD_DashboardAnalytics = React.lazy(() =>
  import("./pages/SD/DASHBOARD_ANALYTICS/DashboardAnalytics")
);

const RC_Dashboard = React.lazy(() => import("./pages/RC/Dashboard"));
const RC_RRTAll = React.lazy(() => import("./pages/RC/RR/all"));
// BTS0513: RC Reporting page
const RC_Report = React.lazy(() => import("./pages/RC/Report"));
const RC_RRTUnclosed = React.lazy(() => import("./pages/RC/RR/unclosed"));
const RC_RRTUnclosedDetail = React.lazy(() =>
  import("./pages/RC/RR/unclosed_detail")
);
const RC_RRTUnclosedHistory = React.lazy(() =>
  import("./pages/RC/RR/unclosed_history")
);
const RC_RRTUnclosedDeliver = React.lazy(() =>
  import("./pages/RC/RR/unclosed_deliver")
);
const RC_RRTUnclosedPartUsage = React.lazy(() =>
  import("./pages/RC/RR/unclosed_part_usage")
);
const RC_RRTUnclosedStopToWork = React.lazy(() =>
  import("./pages/RC/RR/unclosed_stop_to_work")
);

const MASTEDATA_dashboard = React.lazy(() =>
  import("./pages/MASTERDATA/Dashboard")
);
const MASTERDATA_region_all = React.lazy(() =>
  import("./pages/MASTERDATA/region/all")
);
const MASTERDATA_region_create = React.lazy(() =>
  import("./pages/MASTERDATA/region/create")
);
const MASTERDATA_region_edit = React.lazy(() =>
  import("./pages/MASTERDATA/region/edit")
);
const MASTERDATA_manager_all = React.lazy(() =>
  import("./pages/MASTERDATA/manager/all")
);
const MASTERDATA_manager_create = React.lazy(() =>
  import("./pages/MASTERDATA/manager/create")
);
const MASTERDATA_manager_edit = React.lazy(() =>
  import("./pages/MASTERDATA/manager/edit")
);
const MASTERDATA_team_leader_all = React.lazy(() =>
  import("./pages/MASTERDATA/team_leader/all")
);
const MASTERDATA_team_leader_create = React.lazy(() =>
  import("./pages/MASTERDATA/team_leader/create")
);
const MASTERDATA_team_leader_edit = React.lazy(() =>
  import("./pages/MASTERDATA/team_leader/edit")
);
const MASTERDATA_service_engineer_all = React.lazy(() =>
  import("./pages/MASTERDATA/service_engineer/all")
);
const MASTERDATA_service_engineer_create = React.lazy(() =>
  import("./pages/MASTERDATA/service_engineer/create")
);
const MASTERDATA_service_engineer_edit = React.lazy(() =>
  import("./pages/MASTERDATA/service_engineer/edit")
);
const MASTERDATA_service_desk_all = React.lazy(() =>
  import("./pages/MASTERDATA/service_desk/all")
);
const MASTERDATA_service_desk_create = React.lazy(() =>
  import("./pages/MASTERDATA/service_desk/create")
);
const MASTERDATA_service_desk_edit = React.lazy(() =>
  import("./pages/MASTERDATA/service_desk/edit")
);
const MASTERDATA_problem_type_all = React.lazy(() =>
  import("./pages/MASTERDATA/problem_type/all")
);
const MASTERDATA_problem_type_create = React.lazy(() =>
  import("./pages/MASTERDATA/problem_type/create")
);
const MASTERDATA_problem_type_edit = React.lazy(() =>
  import("./pages/MASTERDATA/problem_type/edit")
);
const MASTERDATA_problem_type_group_all = React.lazy(() =>
  import("./pages/MASTERDATA/problem_type_group/all")
);
const MASTERDATA_problem_type_group_create = React.lazy(() =>
  import("./pages/MASTERDATA/problem_type_group/create")
);
const MASTERDATA_problem_type_group_edit = React.lazy(() =>
  import("./pages/MASTERDATA/problem_type_group/edit")
);
const MASTERDATA_priority_all = React.lazy(() =>
  import("./pages/MASTERDATA/priority/all")
);
const MASTERDATA_priority_create = React.lazy(() =>
  import("./pages/MASTERDATA/priority/create")
);
const MASTERDATA_priority_edit = React.lazy(() =>
  import("./pages/MASTERDATA/priority/edit")
);
const MASTERDATA_customer_type_all = React.lazy(() =>
  import("./pages/MASTERDATA/customer_type/all")
);
const MASTERDATA_customer_type_create = React.lazy(() =>
  import("./pages/MASTERDATA/customer_type/create")
);
const MASTERDATA_customer_type_edit = React.lazy(() =>
  import("./pages/MASTERDATA/customer_type/edit")
);
const MASTERDATA_customer_all = React.lazy(() =>
  import("./pages/MASTERDATA/customer/all")
);
const MASTERDATA_customer_create = React.lazy(() =>
  import("./pages/MASTERDATA/customer/create")
);
const MASTERDATA_customer_edit = React.lazy(() =>
  import("./pages/MASTERDATA/customer/edit")
);
const MASTERDATA_service_base_all = React.lazy(() =>
  import("./pages/MASTERDATA/service_base/all")
);
const MASTERDATA_service_base_create = React.lazy(() =>
  import("./pages/MASTERDATA/service_base/create")
);
const MASTERDATA_service_base_edit = React.lazy(() =>
  import("./pages/MASTERDATA/service_base/edit")
);
const MASTERDATA_warehouse_base_all = React.lazy(() =>
  import("./pages/MASTERDATA/warehouse_base/all")
);
const MASTERDATA_warehouse_base_create = React.lazy(() =>
  import("./pages/MASTERDATA/warehouse_base/create")
);
const MASTERDATA_warehouse_base_edit = React.lazy(() =>
  import("./pages/MASTERDATA/warehouse_base/edit")
);
const MASTERDATA_machine_model_all = React.lazy(() =>
  import("./pages/MASTERDATA/machine_model/all")
);
const MASTERDATA_machine_model_create = React.lazy(() =>
  import("./pages/MASTERDATA/machine_model/create")
);
const MASTERDATA_machine_model_edit = React.lazy(() =>
  import("./pages/MASTERDATA/machine_model/edit")
);
const MASTERDATA_machine_vendor_all = React.lazy(() =>
  import("./pages/MASTERDATA/machine_vendor/all")
);
const MASTERDATA_machine_vendor_create = React.lazy(() =>
  import("./pages/MASTERDATA/machine_vendor/create")
);
const MASTERDATA_machine_vendor_edit = React.lazy(() =>
  import("./pages/MASTERDATA/machine_vendor/edit")
);
const MASTERDATA_logistic_staff_all = React.lazy(() =>
  import("./pages/MASTERDATA/logistic_staff/all")
);
const MASTERDATA_logistic_staff_create = React.lazy(() =>
  import("./pages/MASTERDATA/logistic_staff/create")
);
const MASTERDATA_logistic_staff_edit = React.lazy(() =>
  import("./pages/MASTERDATA/logistic_staff/edit")
);
const MASTERDATA_machine_all = React.lazy(() =>
  import("./pages/MASTERDATA/machine/all")
);
const MASTERDATA_machine_create = React.lazy(() =>
  import("./pages/MASTERDATA/machine/create")
);
const MASTERDATA_machine_edit = React.lazy(() =>
  import("./pages/MASTERDATA/machine/edit")
);
const MASTERDATA_repair_center_engineer_all = React.lazy(() =>
  import("./pages/MASTERDATA/repair_center_engineer/all")
);
const MASTERDATA_repair_center_engineer_create = React.lazy(() =>
  import("./pages/MASTERDATA/repair_center_engineer/create")
);
const MASTERDATA_repair_center_engineer_edit = React.lazy(() =>
  import("./pages/MASTERDATA/repair_center_engineer/edit")
);
const MASTERDATA_suspend_status_all = React.lazy(() =>
  import("./pages/MASTERDATA/suspend_status/all")
);
const MASTERDATA_suspend_status_create = React.lazy(() =>
  import("./pages/MASTERDATA/suspend_status/create")
);
const MASTERDATA_suspend_status_edit = React.lazy(() =>
  import("./pages/MASTERDATA/suspend_status/edit")
);
const MASTERDATA_cancel_status_all = React.lazy(() =>
  import("./pages/MASTERDATA/cancel_status/all")
);
const MASTERDATA_cancel_status_create = React.lazy(() =>
  import("./pages/MASTERDATA/cancel_status/create")
);
const MASTERDATA_cancel_status_edit = React.lazy(() =>
  import("./pages/MASTERDATA/cancel_status/edit")
);
const MASTERDATA_reject_status_all = React.lazy(() =>
  import("./pages/MASTERDATA/reject_status/all")
);
const MASTERDATA_reject_status_create = React.lazy(() =>
  import("./pages/MASTERDATA/reject_status/create")
);
const MASTERDATA_reject_status_edit = React.lazy(() =>
  import("./pages/MASTERDATA/reject_status/edit")
);
const MASTERDATA_reason_status_all = React.lazy(() =>
  import("./pages/MASTERDATA/reason_status/all")
);
const MASTERDATA_reason_status_create = React.lazy(() =>
  import("./pages/MASTERDATA/reason_status/create")
);
const MASTERDATA_reason_status_edit = React.lazy(() =>
  import("./pages/MASTERDATA/reason_status/edit")
);
const MASTERDATA_bin_location_all = React.lazy(() =>
  import("./pages/MASTERDATA/bin_location/all")
);
const MASTERDATA_bin_location_create = React.lazy(() =>
  import("./pages/MASTERDATA/bin_location/create")
);
const MASTERDATA_bin_location_edit = React.lazy(() =>
  import("./pages/MASTERDATA/bin_location/edit")
);
const MASTERDATA_part_detail_all = React.lazy(() =>
  import("./pages/MASTERDATA/part_detail/all")
);
const MASTERDATA_part_detail_create = React.lazy(() =>
  import("./pages/MASTERDATA/part_detail/create")
);
const MASTERDATA_part_detail_edit = React.lazy(() =>
  import("./pages/MASTERDATA/part_detail/edit")
);
const MASTERDATA_part_platform_all = React.lazy(() =>
  import("./pages/MASTERDATA/part_platform/all")
);
const MASTERDATA_part_platform_create = React.lazy(() =>
  import("./pages/MASTERDATA/part_platform/create")
);
const MASTERDATA_part_platform_edit = React.lazy(() =>
  import("./pages/MASTERDATA/part_platform/edit")
);
const MASTERDATA_part_repairable_all = React.lazy(() =>
  import("./pages/MASTERDATA/part_repairable/all")
);
const MASTERDATA_part_repairable_create = React.lazy(() =>
  import("./pages/MASTERDATA/part_repairable/create")
);
const MASTERDATA_part_repairable_edit = React.lazy(() =>
  import("./pages/MASTERDATA/part_repairable/edit")
);
const MASTERDATA_part_non_repairable_all = React.lazy(() =>
  import("./pages/MASTERDATA/part_non_repairable/all")
);
const MASTERDATA_part_non_repairable_create = React.lazy(() =>
  import("./pages/MASTERDATA/part_non_repairable/create")
);
const MASTERDATA_part_non_repairable_edit = React.lazy(() =>
  import("./pages/MASTERDATA/part_non_repairable/edit")
);
const MASTERDATA_service_type_all = React.lazy(() =>
  import("./pages/MASTERDATA/service_type/all")
);
const MASTERDATA_service_type_create = React.lazy(() =>
  import("./pages/MASTERDATA/service_type/create")
);
const MASTERDATA_service_type_edit = React.lazy(() =>
  import("./pages/MASTERDATA/service_type/edit")
);
const MASTERDATA_corrective_type_all = React.lazy(() =>
  import("./pages/MASTERDATA/corrective_type/all")
);
const MASTERDATA_corrective_type_create = React.lazy(() =>
  import("./pages/MASTERDATA/corrective_type/create")
);
const MASTERDATA_corrective_type_edit = React.lazy(() =>
  import("./pages/MASTERDATA/corrective_type/edit")
);
const MASTERDATA_asset_platform_all = React.lazy(() =>
  import("./pages/MASTERDATA/asset_platform/all")
);
const MASTERDATA_asset_platform_create = React.lazy(() =>
  import("./pages/MASTERDATA/asset_platform/create")
);
const MASTERDATA_asset_platform_edit = React.lazy(() =>
  import("./pages/MASTERDATA/asset_platform/edit")
);
const MASTERDATA_asset_detail_all = React.lazy(() =>
  import("./pages/MASTERDATA/asset_detail/all")
);
const MASTERDATA_asset_detail_create = React.lazy(() =>
  import("./pages/MASTERDATA/asset_detail/create")
);
const MASTERDATA_asset_detail_edit = React.lazy(() =>
  import("./pages/MASTERDATA/asset_detail/edit")
);
const MASTERDATA_asset_all = React.lazy(() =>
  import("./pages/MASTERDATA/asset/all")
);
const MASTERDATA_asset_create = React.lazy(() =>
  import("./pages/MASTERDATA/asset/create")
);
const MASTERDATA_asset_edit = React.lazy(() =>
  import("./pages/MASTERDATA/asset/edit")
);
const MASTERDATA_entity_all = React.lazy(() =>
  import("./pages/MASTERDATA/entity/all")
);
const MASTERDATA_entity_create = React.lazy(() =>
  import("./pages/MASTERDATA/entity/create")
);
const MASTERDATA_entity_edit = React.lazy(() =>
  import("./pages/MASTERDATA/entity/edit")
);
const MASTERDATA_branch_all = React.lazy(() =>
  import("./pages/MASTERDATA/branch/all")
);
const MASTERDATA_branch_create = React.lazy(() =>
  import("./pages/MASTERDATA/branch/create")
);
const MASTERDATA_branch_edit = React.lazy(() =>
  import("./pages/MASTERDATA/branch/edit")
);
const MASTERDATA_contract_all = React.lazy(() =>
  import("./pages/MASTERDATA/contract/all")
);
const MASTERDATA_contract_create = React.lazy(() =>
  import("./pages/MASTERDATA/contract/create")
);
const MASTERDATA_contract_edit = React.lazy(() =>
  import("./pages/MASTERDATA/contract/edit")
);
const MASTERDATA_machine_type_all = React.lazy(() =>
  import("./pages/MASTERDATA/machine_type/all")
);
const MASTERDATA_machine_type_create = React.lazy(() =>
  import("./pages/MASTERDATA/machine_type/create")
);
const MASTERDATA_machine_type_edit = React.lazy(() =>
  import("./pages/MASTERDATA/machine_type/edit")
);

const TL_Dashboard = React.lazy(() => import("./pages/TL/Dashboard"));
const TL_Detail = React.lazy(() => import("./pages/TL/Detail"));
const TL_History = React.lazy(() => import("./pages/TL/History"));

const MGR_SotDashboard = React.lazy(() =>
  import("./pages/MGR/SotDashboard.jsx")
);
const MGR_SotDetail = React.lazy(() => import("./pages/MGR/SotDetail.jsx"));
const MGR_SotHistory = React.lazy(() => import("./pages/MGR/SotHistory"));
const MGR_PrtDashboard = React.lazy(() =>
  import("./pages/MGR/PrtDashboard.jsx")
);
const MGR_PrtDetail = React.lazy(() => import("./pages/MGR/PrtDetail"));
const MGR_PrtHistory = React.lazy(() => import("./pages/MGR/PrtHistory"));
const MGR_RrtDetail = React.lazy(() => import("./pages/MGR/RrtDetail"));
const MGR_RrtHistory = React.lazy(() => import("./pages/MGR/RrtHistory"));

const FLM_Dashboard = React.lazy(() => import("./pages/FLM/DashboardHome"));
const FLM_JFJobDetail = React.lazy(() => import("./pages/FLM/JF/JobDetail"));
const FLM_JFJobHistory = React.lazy(() => import("./pages/FLM/JF/HistoryHome"));
const FLM_JFJobStopToWork = React.lazy(() =>
  import("./pages/FLM/JF/JobDetailStopToWorkForm")
);
const FLM_JFJobAppointment = React.lazy(() =>
  import("./pages/FLM/JF/AppointmentHome")
);
const FLM_SOTLeave = React.lazy(() =>
  import("./pages/FLM/JobReportDeliveryHome")
);
const FLM_SOTAll = React.lazy(() => import("./pages/FLM/SOT/FlmSotAll"));

const CIT_Dashboard = React.lazy(() => import("./pages/CIT/DashboardHome"));
const CIT_JFJobDetail = React.lazy(() => import("./pages/CIT/JF/JobDetail"));
const CIT_JFJobHistory = React.lazy(() => import("./pages/CIT/JF/HistoryHome"));
const CIT_JFJobStopToWork = React.lazy(() =>
  import("./pages/CIT/JF/JobDetailStopToWorkForm")
);
const CIT_JFJobAppointment = React.lazy(() =>
  import("./pages/CIT/JF/AppointmentHome")
);
const CIT_SOTLeave = React.lazy(() =>
  import("./pages/CIT/JobReportDeliveryHome")
);
const CIT_SOTAll = React.lazy(() => import("./pages/CIT/SOT/CitSotAll"));

const CV_Dashboard = React.lazy(() => import("./pages/CV/DashboardHome"));
const CV_JFJobDetail = React.lazy(() => import("./pages/CV/JF/JobDetail"));
const CV_JFJobHistory = React.lazy(() => import("./pages/CV/JF/HistoryHome"));
const CV_JFJobStopToWork = React.lazy(() =>
  import("./pages/CV/JF/JobDetailStopToWorkForm")
);
const CV_JFJobAppointment = React.lazy(() =>
  import("./pages/CV/JF/AppointmentHome")
);
const CV_SOTLeave = React.lazy(() =>
  import("./pages/CV/JobReportDeliveryHome")
);
const CV_SOTAll = React.lazy(() => import("./pages/CV/SOT/CvSotAll"));
const CV_DSOnResponseHome = React.lazy(() =>
  import("./pages/CV/DSOnResponseHome")
);
const CV_DSOnOpenHome = React.lazy(() => import("./pages/CV/DSOnOpenHome"));
const CV_DSOnEscalatedToCitHome = React.lazy(() =>
  import("./pages/CV/DSOnEscalatedToCitHome")
);
const CV_DSOnEscalatedToSeHome = React.lazy(() =>
  import("./pages/CV/DSOnEscalatedToSeHome")
);
const CV_DSOnProgressHome = React.lazy(() =>
  import("./pages/CV/DSOnProgressHome")
);

const MASTERDATA_first_level_maintenance_all = React.lazy(() =>
  import("./pages/MASTERDATA/first_level_maintenance/all")
);
const MASTERDATA_first_level_maintenance_create = React.lazy(() =>
  import("./pages/MASTERDATA/first_level_maintenance/create")
);
const MASTERDATA_first_level_maintenance_edit = React.lazy(() =>
  import("./pages/MASTERDATA/first_level_maintenance/edit")
);

const MASTERDATA_cash_in_transit_all = React.lazy(() =>
  import("./pages/MASTERDATA/cash_in_transit/all")
);
const MASTERDATA_cash_in_transit_create = React.lazy(() =>
  import("./pages/MASTERDATA/cash_in_transit/create")
);
const MASTERDATA_cash_in_transit_edit = React.lazy(() =>
  import("./pages/MASTERDATA/cash_in_transit/edit")
);

const MASTERDATA_comm_vendor_all = React.lazy(() =>
  import("./pages/MASTERDATA/comm_vendor/all")
);
const MASTERDATA_comm_vendor_create = React.lazy(() =>
  import("./pages/MASTERDATA/comm_vendor/create")
);
const MASTERDATA_comm_vendor_edit = React.lazy(() =>
  import("./pages/MASTERDATA/comm_vendor/edit")
);

const AuthLogin = React.lazy(() => import("./pages/AUTH/AuthLogin"));
const AuthForgetPassword = React.lazy(() =>
  import("./pages/AUTH/AuthForgetPassword")
);
const Profile = React.lazy(() => import("./pages/Profile"));
const ExternalLayout = React.lazy(() => import("./pages/ExternalLayout"));
const ExternalApiDocs = React.lazy(() => import("./pages/ExternalApiDocs"));

import { Modal } from "./components/ui/modal.jsx";
import { useModal } from "./stores/modal.js";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "react-hot-toast";
import ErrorBoundary from "./components/ErrorBoundary";

const Corrective = React.lazy(() =>
  import("./pages/SE/JF/maintenance/Corrective")
);
const Preventive = React.lazy(() =>
  import("./pages/SE/JF/maintenance/Preventive")
);
const Other = React.lazy(() => import("./pages/SE/JF/maintenance/Other"));
const DashboardEsc = React.lazy(() =>
  import("./pages/SD/DASHBOARD_ESC/DashboardEsc")
);

const MappingAreaHome = React.lazy(() =>
  import("./pages/MASTERDATA/mapping_area/MappingAreaHome")
);
const MappingAreaCreate = React.lazy(() =>
  import("./pages/MASTERDATA/mapping_area/MappingAreaCreate")
);
const MappingAreaEdit = React.lazy(() =>
  import("./pages/MASTERDATA/mapping_area/MappingAreaEdit")
);
const SettingHome = React.lazy(() => import("./pages/MASTERDATA/setting/all"));

const FLM_DSOnResponseHome = React.lazy(() =>
  import("./pages/FLM/DSOnResponseHome")
);
const FLM_DSOnOpenHome = React.lazy(() => import("./pages/FLM/DSOnOpenHome"));
const FLM_DSOnEscalatedToCitHome = React.lazy(() =>
  import("./pages/FLM/DSOnEscalatedToCitHome")
);
const FLM_DSOnEscalatedToSeHome = React.lazy(() =>
  import("./pages/FLM/DSOnEscalatedToSeHome")
);
const FLM_DSOnProgressHome = React.lazy(() =>
  import("./pages/FLM/DSOnProgressHome")
);

const CIT_DSOnResponseHome = React.lazy(() =>
  import("./pages/CIT/DSOnResponseHome")
);
const CIT_DSOnOpenHome = React.lazy(() => import("./pages/CIT/DSOnOpenHome"));
const CIT_DSOnEscalatedToFlmHome = React.lazy(() =>
  import("./pages/CIT/DSOnEscalatedToFlmHome")
);
const CIT_DSOnEscalatedToSeHome = React.lazy(() =>
  import("./pages/CIT/DSOnEscalatedToSeHome")
);
const CIT_DSOnProgressHome = React.lazy(() =>
  import("./pages/CIT/DSOnProgressHome")
);
const CIT_DSOnCashEmptyHome = React.lazy(() =>
  import("./pages/CIT/DSOnCashEmptyHome")
);

const SD_ReAssign = React.lazy(() => import("./pages/SD/SOT/ReAssign"));

const MASTERDATA_admin_all = React.lazy(() =>
  import("./pages/MASTERDATA/admin/all")
);
const MASTERDATA_admin_create = React.lazy(() =>
  import("./pages/MASTERDATA/admin/create")
);
const MASTERDATA_admin_edit = React.lazy(() =>
  import("./pages/MASTERDATA/admin/edit")
);

const MASTERDATA_logging_all = React.lazy(() =>
  import("./pages/MASTERDATA/logging/all")
);
const MASTERDATA_post_status_fail_all = React.lazy(() =>
  import("./pages/MASTERDATA/post_status_fail/all")
);

const MASTERDATA_remote_operation_center_all = React.lazy(() =>
  import("./pages/MASTERDATA/remote_operation_center/all")
);
const MASTERDATA_remote_operation_center_create = React.lazy(() =>
  import("./pages/MASTERDATA/remote_operation_center/create")
);
const MASTERDATA_remote_operation_center_edit = React.lazy(() =>
  import("./pages/MASTERDATA/remote_operation_center/edit")
);

const MASTERDATA_client_all = React.lazy(() =>
  import("./pages/MASTERDATA/client/all")
);
const MASTERDATA_client_create = React.lazy(() =>
  import("./pages/MASTERDATA/client/create")
);
const MASTERDATA_client_edit = React.lazy(() =>
  import("./pages/MASTERDATA/client/edit")
);

const ROCDashboard = React.lazy(() => import("./pages/ROC/Dashboard"));
const ROCDashboardEsc = React.lazy(() =>
  import("./pages/ROC/DASHBOARD_ESC/DashboardEsc")
);
const ROCSOTAll = React.lazy(() => import("./pages/ROC/SOT/AllHome"));
const ROCSOTSummary = React.lazy(() => import("./pages/ROC/SOT/SummaryHome"));
const ROCSOTHistory = React.lazy(() => import("./pages/ROC/SOT/HistoryHome"));
const ROCPRAll = React.lazy(() => import("./pages/ROC/PR/AllHome"));
const ROCPRDetail = React.lazy(() => import("./pages/ROC/PR/DetailHome"));
const ROCPRHistory = React.lazy(() => import("./pages/ROC/PR/HistoryHome"));

const CLIENTDashboard = React.lazy(() => import("./pages/CLIENT/Dashboard"));
const CLIENTSOTAll = React.lazy(() => import("./pages/CLIENT/SOT/AllHome"));
const CLIENTSOTSummary = React.lazy(() =>
  import("./pages/CLIENT/SOT/SummaryHome")
);
const CLIENTSOTHistory = React.lazy(() =>
  import("./pages/CLIENT/SOT/HistoryHome")
);
const CLIENTMachineSotDetail = React.lazy(() =>
  import("./pages/CLIENT/MachineSotDetail")
);

export default function App() {
  const modal = useModal((state) => state.content);
  return (
    <>
      <BrowserRouter>
        <div>
          <Toaster />
          <AnimatePresence>{modal?.state && <Modal />}</AnimatePresence>
          <ErrorBoundary>
              <Routes>
                <Route path="/" element={<Navigate to="/auth/login" />} />
                <Route path="/auth/login" element={<AuthLogin />}></Route>
                <Route
                  path="/auth/forget_password"
                  element={<AuthForgetPassword />}
                />

                {/* External API Routes */}
                <Route element={<ExternalLayout />}>
                  <Route
                    path="/external-api-docs"
                    element={<ExternalApiDocs />}
                  />
                </Route>

                <Route element={<Layout />}>
                  <Route path="/profile" element={<Profile />} />
                  <Route
                    path="/remote-operation-center/dashboard"
                    element={<ROCDashboard />}
                  />
                  <Route
                    path="/remote-operation-center/dashboard/first-level"
                    element={<ROCDashboardEsc />}
                  />
                  <Route
                    path="/remote-operation-center/dashboard/cash-in-transit"
                    element={<ROCDashboardEsc />}
                  />
                  <Route
                    path="/remote-operation-center/dashboard/comm-vendor"
                    element={<ROCDashboardEsc />}
                  />
                  <Route
                    path="/remote-operation-center/sot/all"
                    element={<ROCSOTAll />}
                  />
                  <Route
                    path="/remote-operation-center/sot/:id/summary"
                    element={<ROCSOTSummary />}
                  />
                  <Route
                    path="/remote-operation-center/sot/:id/history"
                    element={<ROCSOTHistory />}
                  />
                  <Route
                    path="/remote-operation-center/pr/all"
                    element={<ROCPRAll />}
                  />
                  <Route
                    path="/remote-operation-center/pr/:id/detail"
                    element={<ROCPRDetail />}
                  />
                  <Route
                    path="/remote-operation-center/pr/:id/history"
                    element={<ROCPRHistory />}
                  />
                  <Route
                    path="/client/dashboard"
                    element={<CLIENTDashboard />}
                  />
                  <Route path="/client/sot/all" element={<CLIENTSOTAll />} />
                  <Route
                    path="/client/sot/:id/summary"
                    element={<CLIENTSOTSummary />}
                  />
                  <Route
                    path="/client/sot/:id/history"
                    element={<CLIENTSOTHistory />}
                  />
                  <Route
                    path="/client/machine/:machineId/sot"
                    element={<CLIENTMachineSotDetail />}
                  />
                  <Route
                    path="/service-desk/dashboard"
                    element={<SD_Dashboard />}
                  />
                  <Route
                    path="/service-desk/dashboard/service-level"
                    element={<DashboardEsc />}
                  />
                  <Route
                    path="/service-desk/dashboard/first-level"
                    element={<DashboardEsc />}
                  />
                  <Route
                    path="/service-desk/dashboard/cash-in-transit"
                    element={<DashboardEsc />}
                  />
                  <Route
                    path="/service-desk/dashboard/comm-vendor"
                    element={<DashboardEsc />}
                  />
                  <Route
                    path="/service-desk/dashboard/analytics"
                    element={<SD_DashboardAnalytics />}
                  />
                  <Route
                    path="/service-desk/sot/:id/rejected"
                    element={<SD_ReAssign />}
                  />
                  <Route path="/cit/dashboard" element={<CIT_Dashboard />} />
                  <Route
                    path="/cit/dashboard/cash-empty"
                    element={<CIT_DSOnCashEmptyHome />}
                  />
                  <Route
                    path="/cit/dashboard/on-response"
                    element={<CIT_DSOnResponseHome />}
                  />
                  <Route
                    path="/cit/dashboard/on-progress"
                    element={<CIT_DSOnProgressHome />}
                  />
                  <Route
                    path="/cit/dashboard/long-ticket"
                    element={<CIT_DSOnOpenHome />}
                  />
                  <Route
                    path="/cit/dashboard/escalated-to-se"
                    element={<CIT_DSOnEscalatedToSeHome />}
                  />
                  <Route
                    path="/cit/dashboard/escalated-to-flm"
                    element={<CIT_DSOnEscalatedToFlmHome />}
                  />
                  <Route path="/cit/sot/all" element={<CIT_SOTAll />} />
                  <Route path="/cit/jf/job/:id" element={<CIT_JFJobDetail />} />
                  <Route
                    path="/cit/jf/new/:id/accept"
                    element={<CIT_JFJobAppointment />}
                  />
                  <Route
                    path="/cit/jf/job/:id/history"
                    element={<CIT_JFJobHistory />}
                  />
                  <Route
                    path="/cit/jf/job/:id/stop-to-work"
                    element={<CIT_JFJobStopToWork />}
                  />
                  <Route path="/cit/sot/leave" element={<CIT_SOTLeave />} />
                  <Route path="/flm/dashboard" element={<FLM_Dashboard />} />
                  <Route
                    path="/flm/dashboard/on-response"
                    element={<FLM_DSOnResponseHome />}
                  />
                  <Route
                    path="/flm/dashboard/on-progress"
                    element={<FLM_DSOnProgressHome />}
                  />
                  <Route
                    path="/flm/dashboard/long-ticket"
                    element={<FLM_DSOnOpenHome />}
                  />
                  <Route
                    path="/flm/dashboard/escalated-to-se"
                    element={<FLM_DSOnEscalatedToSeHome />}
                  />
                  <Route
                    path="/flm/dashboard/escalated-to-cit"
                    element={<FLM_DSOnEscalatedToCitHome />}
                  />
                  <Route path="/flm/sot/all" element={<FLM_SOTAll />} />
                  <Route path="/flm/jf/job/:id" element={<FLM_JFJobDetail />} />
                  <Route
                    path="/flm/jf/new/:id/accept"
                    element={<FLM_JFJobAppointment />}
                  />
                  <Route
                    path="/flm/jf/job/:id/history"
                    element={<FLM_JFJobHistory />}
                  />
                  <Route
                    path="/flm/jf/job/:id/stop-to-work"
                    element={<FLM_JFJobStopToWork />}
                  />
                  <Route path="/flm/sot/leave" element={<FLM_SOTLeave />} />
                  <Route path="/cv/dashboard" element={<CV_Dashboard />} />
                  <Route
                    path="/cv/dashboard/on-response"
                    element={<CV_DSOnResponseHome />}
                  />
                  <Route
                    path="/cv/dashboard/on-progress"
                    element={<CV_DSOnProgressHome />}
                  />
                  <Route
                    path="/cv/dashboard/long-ticket"
                    element={<CV_DSOnOpenHome />}
                  />
                  <Route
                    path="/cv/dashboard/escalated-to-se"
                    element={<CV_DSOnEscalatedToSeHome />}
                  />
                  <Route
                    path="/cv/dashboard/escalated-to-cit"
                    element={<CV_DSOnEscalatedToCitHome />}
                  />
                  <Route path="/cv/sot/all" element={<CV_SOTAll />} />
                  <Route path="/cv/jf/job/:id" element={<CV_JFJobDetail />} />
                  <Route
                    path="/cv/jf/new/:id/accept"
                    element={<CV_JFJobAppointment />}
                  />
                  <Route
                    path="/cv/jf/job/:id/history"
                    element={<CV_JFJobHistory />}
                  />
                  <Route
                    path="/cv/jf/job/:id/stop-to-work"
                    element={<CV_JFJobStopToWork />}
                  />
                  <Route path="/cv/sot/leave" element={<CV_SOTLeave />} />
                  <Route
                    path="/admin/first_level_maintenance/all"
                    element={<MASTERDATA_first_level_maintenance_all />}
                  />
                  <Route
                    path="/admin/first_level_maintenance/create"
                    element={<MASTERDATA_first_level_maintenance_create />}
                  />
                  <Route
                    path="/admin/first_level_maintenance/:id/edit"
                    element={<MASTERDATA_first_level_maintenance_edit />}
                  />
                  <Route
                    path="/admin/comm_vendor/all"
                    element={<MASTERDATA_comm_vendor_all />}
                  />
                  <Route
                    path="/admin/comm_vendor/create"
                    element={<MASTERDATA_comm_vendor_create />}
                  />
                  <Route
                    path="/admin/comm_vendor/:id/edit"
                    element={<MASTERDATA_comm_vendor_edit />}
                  />
                  <Route
                    path="/admin/cash_in_transit/all"
                    element={<MASTERDATA_cash_in_transit_all />}
                  />
                  <Route
                    path="/admin/cash_in_transit/create"
                    element={<MASTERDATA_cash_in_transit_create />}
                  />
                  <Route
                    path="/admin/cash_in_transit/:id/edit"
                    element={<MASTERDATA_cash_in_transit_edit />}
                  />
                  <Route
                    path="/admin/logging/all"
                    element={<MASTERDATA_logging_all />}
                  />
                  <Route
                    path="/admin/post-status-fail/all"
                    element={<MASTERDATA_post_status_fail_all />}
                  />
                  <Route
                    path="/admin/mapping_area/all"
                    element={<MappingAreaHome />}
                  />
                  <Route
                    path="/admin/mapping_area/create"
                    element={<MappingAreaCreate />}
                  />
                  <Route
                    path="/admin/mapping_area/:id/edit"
                    element={<MappingAreaEdit />}
                  />
                  <Route path="/admin/setting/all" element={<SettingHome />} />
                  <Route
                    path="/admin/machine/all"
                    element={<MASTERDATA_machine_all />}
                  />
                  <Route
                    path="/admin/machine/create"
                    element={<MASTERDATA_machine_create />}
                  />
                  <Route
                    path="/admin/machine/:id/edit"
                    element={<MASTERDATA_machine_edit />}
                  />
                  <Route
                    path="/service-engineer/dashboard"
                    element={<SE_Dashboard />}
                  />
                  <Route
                    path="/service-engineer/jf/maintenance/corrective"
                    element={<Corrective />}
                  />
                  <Route
                    path="/service-engineer/jf/maintenance/preventive"
                    element={<Preventive />}
                  />
                  <Route
                    path="/service-engineer/jf/maintenance/other"
                    element={<Other />}
                  />
                  <Route
                    path="/service-engineer/jf/maintenance/:service_type"
                    element={<SE_JFServiceType />}
                  />
                  <Route
                    path="/service-engineer/jf/new/:id/accept"
                    element={<SE_JFJobAppointment />}
                  />
                  <Route
                    path="/service-engineer/jf/job/:id"
                    element={<SE_JFJobDetail />}
                  />
                  <Route
                    path="/service-engineer/jf/job/:id/history"
                    element={<SE_JFJobHistory />}
                  />
                  <Route
                    path="/service-engineer/jf/job/:id/stop-to-work"
                    element={<SE_JFJobStopToWork />}
                  />
                  <Route
                    path="/service-engineer/jf/job/:id/part-usage"
                    element={<SE_JFJobPartUsage />}
                  />
                  <Route
                    path="/service-engineer/jf/job/:id/part-request"
                    element={<SE_JFJobPartRequest />}
                  />
                  <Route
                    path="/service-engineer/sot/leave"
                    element={<SE_SOTLeave />}
                  />
                  <Route
                    path="/service-engineer/sot/part-list"
                    element={<SE_PartList />}
                  />
                  <Route
                    path="/service-engineer/sot/part-return"
                    element={<SE_PartReturn />}
                  />
                  <Route
                    path="/service-engineer/sot/part-request"
                    element={<SE_PartRequest />}
                  />
                  <Route
                    path="/service-engineer/sot/part-request/:id"
                    element={<SE_PartRequestDetail />}
                  />
                  <Route
                    path="/manager/service_engineer/dashboard"
                    element={<MGR_SotDashboard />}
                  />
                  <Route path="/manager/:id/sot" element={<MGR_SotDetail />} />
                  <Route
                    path="/manager/:id/sot/history"
                    element={<MGR_SotHistory />}
                  />
                  <Route
                    path="/manager/logistic/dashboard"
                    element={<MGR_PrtDashboard />}
                  />
                  <Route path="/manager/:id/prt" element={<MGR_PrtDetail />} />
                  <Route
                    path="/manager/:id/prt/history"
                    element={<MGR_PrtHistory />}
                  />
                  <Route path="/manager/:id/rrt" element={<MGR_RrtDetail />} />
                  <Route
                    path="/manager/:id/rrt/history"
                    element={<MGR_RrtHistory />}
                  />
                  <Route
                    path="/team-leader/dashboard"
                    element={<TL_Dashboard />}
                  />
                  <Route path="/team-leader/:id/sot" element={<TL_Detail />} />
                  <Route
                    path="/team-leader/:id/sot/history"
                    element={<TL_History />}
                  />
                  <Route
                    path="/admin/dashboard"
                    element={<MASTEDATA_dashboard />}
                  />
                  <Route
                    path="/admin/admin/all"
                    element={<MASTERDATA_admin_all />}
                  />
                  <Route
                    path="/admin/admin/create"
                    element={<MASTERDATA_admin_create />}
                  />
                  <Route
                    path="/admin/admin/:id/edit"
                    element={<MASTERDATA_admin_edit />}
                  />
                  <Route
                    path="/admin/region/all"
                    element={<MASTERDATA_region_all />}
                  />
                  <Route
                    path="/admin/region/create"
                    element={<MASTERDATA_region_create />}
                  />
                  <Route
                    path="/admin/region/:id/edit"
                    element={<MASTERDATA_region_edit />}
                  />
                  <Route
                    path="/admin/remote_operation_center/all"
                    element={<MASTERDATA_remote_operation_center_all />}
                  />
                  <Route
                    path="/admin/remote_operation_center/create"
                    element={<MASTERDATA_remote_operation_center_create />}
                  />
                  <Route
                    path="/admin/remote_operation_center/:id/edit"
                    element={<MASTERDATA_remote_operation_center_edit />}
                  />
                  <Route
                    path="/admin/client/all"
                    element={<MASTERDATA_client_all />}
                  />
                  <Route
                    path="/admin/client/create"
                    element={<MASTERDATA_client_create />}
                  />
                  <Route
                    path="/admin/client/:id/edit"
                    element={<MASTERDATA_client_edit />}
                  />
                  <Route
                    path="/admin/manager/all"
                    element={<MASTERDATA_manager_all />}
                  />
                  <Route
                    path="/admin/manager/create"
                    element={<MASTERDATA_manager_create />}
                  />
                  <Route
                    path="/admin/manager/:id/edit"
                    element={<MASTERDATA_manager_edit />}
                  />
                  <Route
                    path="/admin/team-leader/all"
                    element={<MASTERDATA_team_leader_all />}
                  />
                  <Route
                    path="/admin/team-leader/create"
                    element={<MASTERDATA_team_leader_create />}
                  />
                  <Route
                    path="/admin/team-leader/:id/edit"
                    element={<MASTERDATA_team_leader_edit />}
                  />
                  <Route
                    path="/admin/service_engineer/all"
                    element={<MASTERDATA_service_engineer_all />}
                  />
                  <Route
                    path="/admin/service_engineer/create"
                    element={<MASTERDATA_service_engineer_create />}
                  />
                  <Route
                    path="/admin/service_engineer/:id/edit"
                    element={<MASTERDATA_service_engineer_edit />}
                  />
                  <Route
                    path="/admin/service_desk/all"
                    element={<MASTERDATA_service_desk_all />}
                  />
                  <Route
                    path="/admin/service_desk/create"
                    element={<MASTERDATA_service_desk_create />}
                  />
                  <Route
                    path="/admin/service_desk/:id/edit"
                    element={<MASTERDATA_service_desk_edit />}
                  />
                  <Route
                    path="/admin/repair_center_engineer/all"
                    element={<MASTERDATA_repair_center_engineer_all />}
                  />
                  <Route
                    path="/admin/repair_center_engineer/create"
                    element={<MASTERDATA_repair_center_engineer_create />}
                  />
                  <Route
                    path="/admin/repair_center_engineer/:id/edit"
                    element={<MASTERDATA_repair_center_engineer_edit />}
                  />
                  <Route
                    path="/admin/problem-type/all"
                    element={<MASTERDATA_problem_type_all />}
                  />
                  <Route
                    path="/admin/problem-type/create"
                    element={<MASTERDATA_problem_type_create />}
                  />
                  <Route
                    path="/admin/problem-type/:id/edit"
                    element={<MASTERDATA_problem_type_edit />}
                  />
                  <Route
                    path="/admin/problem_type_group/all"
                    element={<MASTERDATA_problem_type_group_all />}
                  />
                  <Route
                    path="/admin/problem_type_group/create"
                    element={<MASTERDATA_problem_type_group_create />}
                  />
                  <Route
                    path="/admin/problem_type_group/:id/edit"
                    element={<MASTERDATA_problem_type_group_edit />}
                  />
                  <Route
                    path="/admin/priority/all"
                    element={<MASTERDATA_priority_all />}
                  />
                  <Route
                    path="/admin/priority/create"
                    element={<MASTERDATA_priority_create />}
                  />
                  <Route
                    path="/admin/priority/:id/edit"
                    element={<MASTERDATA_priority_edit />}
                  />
                  <Route
                    path="/admin/service-base/all"
                    element={<MASTERDATA_service_base_all />}
                  />
                  <Route
                    path="/admin/service-base/create"
                    element={<MASTERDATA_service_base_create />}
                  />
                  <Route
                    path="/admin/service-base/:id/edit"
                    element={<MASTERDATA_service_base_edit />}
                  />
                  <Route
                    path="/admin/customer-type/all"
                    element={<MASTERDATA_customer_type_all />}
                  />
                  <Route
                    path="/admin/customer-type/create"
                    element={<MASTERDATA_customer_type_create />}
                  />
                  <Route
                    path="/admin/customer-type/:id/edit"
                    element={<MASTERDATA_customer_type_edit />}
                  />
                  <Route
                    path="/admin/customer/all"
                    element={<MASTERDATA_customer_all />}
                  />
                  <Route
                    path="/admin/customer/create"
                    element={<MASTERDATA_customer_create />}
                  />
                  <Route
                    path="/admin/customer/:id/edit"
                    element={<MASTERDATA_customer_edit />}
                  />
                  <Route
                    path="/admin/machine_type/all"
                    element={<MASTERDATA_machine_type_all />}
                  />
                  <Route
                    path="/admin/machine_type/create"
                    element={<MASTERDATA_machine_type_create />}
                  />
                  <Route
                    path="/admin/machine_type/:id/edit"
                    element={<MASTERDATA_machine_type_edit />}
                  />
                  <Route
                    path="/admin/machine_model/all"
                    element={<MASTERDATA_machine_model_all />}
                  />
                  <Route
                    path="/admin/machine_model/create"
                    element={<MASTERDATA_machine_model_create />}
                  />
                  <Route
                    path="/admin/machine_model/:id/edit"
                    element={<MASTERDATA_machine_model_edit />}
                  />
                  <Route
                    path="/admin/machine_vendor/all"
                    element={<MASTERDATA_machine_vendor_all />}
                  />
                  <Route
                    path="/admin/machine_vendor/create"
                    element={<MASTERDATA_machine_vendor_create />}
                  />
                  <Route
                    path="/admin/machine_vendor/:id/edit"
                    element={<MASTERDATA_machine_vendor_edit />}
                  />
                  <Route
                    path="/admin/logistic_staff/all"
                    element={<MASTERDATA_logistic_staff_all />}
                  />
                  <Route
                    path="/admin/logistic_staff/create"
                    element={<MASTERDATA_logistic_staff_create />}
                  />
                  <Route
                    path="/admin/logistic_staff/:id/edit"
                    element={<MASTERDATA_logistic_staff_edit />}
                  />
                  <Route
                    path="/admin/suspend_status/all"
                    element={<MASTERDATA_suspend_status_all />}
                  />
                  <Route
                    path="/admin/suspend_status/create"
                    element={<MASTERDATA_suspend_status_create />}
                  />
                  <Route
                    path="/admin/suspend_status/:id/edit"
                    element={<MASTERDATA_suspend_status_edit />}
                  />
                  <Route
                    path="/admin/cancel_status/all"
                    element={<MASTERDATA_cancel_status_all />}
                  />
                  <Route
                    path="/admin/cancel_status/create"
                    element={<MASTERDATA_cancel_status_create />}
                  />
                  <Route
                    path="/admin/cancel_status/:id/edit"
                    element={<MASTERDATA_cancel_status_edit />}
                  />
                  <Route
                    path="/admin/reject_status/all"
                    element={<MASTERDATA_reject_status_all />}
                  />
                  <Route
                    path="/admin/reject_status/create"
                    element={<MASTERDATA_reject_status_create />}
                  />
                  <Route
                    path="/admin/reject_status/:id/edit"
                    element={<MASTERDATA_reject_status_edit />}
                  />
                  <Route
                    path="/admin/reason_status/all"
                    element={<MASTERDATA_reason_status_all />}
                  />
                  <Route
                    path="/admin/reason_status/create"
                    element={<MASTERDATA_reason_status_create />}
                  />
                  <Route
                    path="/admin/reason_status/:id/edit"
                    element={<MASTERDATA_reason_status_edit />}
                  />
                  <Route
                    path="/admin/part_detail/all"
                    element={<MASTERDATA_part_detail_all />}
                  />
                  <Route
                    path="/admin/bin_location/all"
                    element={<MASTERDATA_bin_location_all />}
                  />
                  <Route
                    path="/admin/bin_location/create"
                    element={<MASTERDATA_bin_location_create />}
                  />
                  <Route
                    path="/admin/bin_location/:id/edit"
                    element={<MASTERDATA_bin_location_edit />}
                  />
                  <Route
                    path="/admin/entity/all"
                    element={<MASTERDATA_entity_all />}
                  />
                  <Route
                    path="/admin/entity/create"
                    element={<MASTERDATA_entity_create />}
                  />
                  <Route
                    path="/admin/entity/:id/edit"
                    element={<MASTERDATA_entity_edit />}
                  />
                  <Route
                    path="/admin/branch/all"
                    element={<MASTERDATA_branch_all />}
                  />
                  <Route
                    path="/admin/branch/create"
                    element={<MASTERDATA_branch_create />}
                  />
                  <Route
                    path="/admin/branch/:id/edit"
                    element={<MASTERDATA_branch_edit />}
                  />
                  <Route
                    path="/admin/contract/all"
                    element={<MASTERDATA_contract_all />}
                  />
                  <Route
                    path="/admin/contract/create"
                    element={<MASTERDATA_contract_create />}
                  />
                  <Route
                    path="/admin/contract/:id/edit"
                    element={<MASTERDATA_contract_edit />}
                  />
                  <Route
                    path="/admin/part_detail/create"
                    element={<MASTERDATA_part_detail_create />}
                  />
                  <Route
                    path="/admin/part_detail/:id/edit"
                    element={<MASTERDATA_part_detail_edit />}
                  />
                  <Route
                    path="/admin/part_platform/all"
                    element={<MASTERDATA_part_platform_all />}
                  />
                  <Route
                    path="/admin/part_platform/create"
                    element={<MASTERDATA_part_platform_create />}
                  />
                  <Route
                    path="/admin/part_platform/:id/edit"
                    element={<MASTERDATA_part_platform_edit />}
                  />
                  <Route
                    path="/admin/part_repairable/all"
                    element={<MASTERDATA_part_repairable_all />}
                  />
                  <Route
                    path="/admin/part_repairable/create"
                    element={<MASTERDATA_part_repairable_create />}
                  />
                  <Route
                    path="/admin/part_repairable/:id/edit"
                    element={<MASTERDATA_part_repairable_edit />}
                  />
                  <Route
                    path="/admin/part_non_repairable/all"
                    element={<MASTERDATA_part_non_repairable_all />}
                  />
                  <Route
                    path="/admin/part_non_repairable/create"
                    element={<MASTERDATA_part_non_repairable_create />}
                  />
                  <Route
                    path="/admin/part_non_repairable/:id/edit"
                    element={<MASTERDATA_part_non_repairable_edit />}
                  />
                  <Route
                    path="/admin/service_type/all"
                    element={<MASTERDATA_service_type_all />}
                  />
                  <Route
                    path="/admin/service_type/create"
                    element={<MASTERDATA_service_type_create />}
                  />
                  <Route
                    path="/admin/service_type/:id/edit"
                    element={<MASTERDATA_service_type_edit />}
                  />
                  <Route
                    path="/admin/warehouse_base/all"
                    element={<MASTERDATA_warehouse_base_all />}
                  />
                  <Route
                    path="/admin/warehouse_base/create"
                    element={<MASTERDATA_warehouse_base_create />}
                  />
                  <Route
                    path="/admin/warehouse_base/:id/edit"
                    element={<MASTERDATA_warehouse_base_edit />}
                  />
                  <Route
                    path="/admin/corrective_type/all"
                    element={<MASTERDATA_corrective_type_all />}
                  />
                  <Route
                    path="/admin/corrective_type/create"
                    element={<MASTERDATA_corrective_type_create />}
                  />
                  <Route
                    path="/admin/corrective_type/:id/edit"
                    element={<MASTERDATA_corrective_type_edit />}
                  />
                  <Route
                    path="/admin/asset_platform/all"
                    element={<MASTERDATA_asset_platform_all />}
                  />
                  <Route
                    path="/admin/asset_platform/create"
                    element={<MASTERDATA_asset_platform_create />}
                  />
                  <Route
                    path="/admin/asset_platform/:id/edit"
                    element={<MASTERDATA_asset_platform_edit />}
                  />
                  <Route
                    path="/admin/asset_detail/all"
                    element={<MASTERDATA_asset_detail_all />}
                  />
                  <Route
                    path="/admin/asset_detail/create"
                    element={<MASTERDATA_asset_detail_create />}
                  />
                  <Route
                    path="/admin/asset_detail/:id/edit"
                    element={<MASTERDATA_asset_detail_edit />}
                  />
                  <Route
                    path="/admin/asset/all"
                    element={<MASTERDATA_asset_all />}
                  />
                  <Route
                    path="/admin/asset/create"
                    element={<MASTERDATA_asset_create />}
                  />
                  <Route
                    path="/admin/asset/:id/edit"
                    element={<MASTERDATA_asset_edit />}
                  />
                  <Route path="/service-desk/sot/all" element={<SD_SOTAll />} />
                  <Route
                    path="/service-desk/sot/create"
                    element={<SD_SOTCreate />}
                  />
                  <Route
                    path="/service-desk/sot/cancel"
                    element={<SD_SOTCancel />}
                  />
                  <Route
                    path="/service-desk/sot/:id/history"
                    element={<SD_SOTHistory />}
                  />
                  <Route
                    path="/service-desk/sot/:id/summary"
                    element={<SD_SOTSummary />}
                  />
                  <Route
                    path="/service-desk/sot/:id/edit"
                    element={<SD_SOTEdit />}
                  />
                  <Route
                    path="/service-desk/sot/:id/appointment"
                    element={<SD_SOTappointment />}
                  />
                  <Route
                    path="/service-desk/sot/:id/part_request"
                    element={<SD_SOTpart_request />}
                  />
                  <Route path="/service-desk/op/all" element={<SD_OPAll />} />
                  <Route
                    path="/service-desk/op/create"
                    element={<SD_OPCreate />}
                  />
                  <Route
                    path="/service-desk/op/:id/edit"
                    element={<SD_OPEdit />}
                  />
                  <Route path="/service-desk/pr/all" element={<SD_PRAll />} />
                  <Route
                    path="/service-desk/pr/:id"
                    element={<SD_PRdetail />}
                  />
                  <Route
                    path="/service-desk/pr/:id/history"
                    element={<SD_PRhistory />}
                  />
                  <Route
                    path="/logistic/dashboard"
                    element={<LOGISTIC_Dashboard />}
                  />
                  <Route
                    path="/logistic/pr/all"
                    element={<LOGISTIC_PRTAll />}
                  />
                  <Route
                    path="/logistic/pr/unclosed"
                    element={<LOGISTIC_PRTUnclosed />}
                  />
                  <Route
                    path="/logistic/pr/unclosed/:id"
                    element={<LOGISTIC_PRTUnclosedDetail />}
                  />
                  <Route
                    path="/logistic/pr/unclosed/:id/history"
                    element={<LOGISTIC_PRTUnclosedHistory />}
                  />
                  <Route
                    path="/logistic/pr/unclosed/:id/deliver"
                    element={<LOGISTIC_PRTUnclosedDeliver />}
                  />
                  <Route
                    path="/logistic/pr/closed"
                    element={<LOGISTIC_PRTClosed />}
                  />
                  <Route
                    path="/logistic/pr/pending"
                    element={<LOGISTIC_PRTPending />}
                  />
                  <Route
                    path="/logistic/pr/closed/:id"
                    element={<LOGISTIC_PRTClosedDetail />}
                  />
                  <Route
                    path="/logistic/pr/closed/:id/history"
                    element={<LOGISTIC_PRTClosedHistory />}
                  />
                  <Route
                    path="/logistic/rr/all"
                    element={<LOGISTIC_RRTAll />}
                  />
                  <Route
                    path="/logistic/rr/create"
                    element={<LOGISTIC_RRTCreate />}
                  />
                  <Route
                    path="/logistic/rr/:id"
                    element={<LOGISTIC_RRTShow />}
                  />
                  <Route
                    path="/logistic/rr/:id/history"
                    element={<LOGISTIC_RRTHistory />}
                  />
                  <Route
                    path="/logistic/part-returned/prt/all"
                    element={<LOGISTIC_PART_RETURNprt />}
                  />
                  <Route
                    path="/logistic/part-returned/rrt/all"
                    element={<LOGISTIC_PART_RETURNrrt />}
                  />
                  <Route
                    path="/logistic/asset"
                    element={<LOGISTIC_AssetAll />}
                  />
                  <Route
                    path="/logistic/asset/create"
                    element={<LOGISTIC_AssetCreate />}
                  />
                  <Route
                    path="/logistic/asset/:id"
                    element={<LOGISTIC_AssetDetail />}
                  />
                  <Route
                    path="/logistic/asset/:id/edit"
                    element={<LOGISTIC_AssetEdit />}
                  />
                  <Route
                    path="/logistic/asset/transfer"
                    element={<LOGISTIC_AssetTransfer />}
                  />
                  <Route
                    path="/logistic/asset/condition"
                    element={<LOGISTIC_AssetCondition />}
                  />
                  <Route
                    path="/logistic/part_repairable"
                    element={<LOGISTIC_PartRepairableAll />}
                  />
                  <Route
                    path="/logistic/part_repairable/create"
                    element={<LOGISTIC_PartRepairableCreate />}
                  />
                  <Route
                    path="/logistic/part_repairable/:id"
                    element={<LOGISTIC_PartRepairableShow />}
                  />
                  <Route
                    path="/logistic/part_repairable/:id/edit"
                    element={<LOGISTIC_PartRepairableEdit />}
                  />
                  <Route
                    path="/logistic/part_repairable/transfer"
                    element={<LOGISTIC_PartRepairableTransfer />}
                  />
                  <Route
                    path="/logistic/part_repairable/condition"
                    element={<LOGISTIC_PartRepairableCondition />}
                  />
                  <Route
                    path="/logistic/part_non_repairable"
                    element={<LOGISTIC_PartNonRepairableAll />}
                  />
                  <Route
                    path="/logistic/part_non_repairable/create"
                    element={<LOGISTIC_PartNonRepairableCreate />}
                  />
                  <Route
                    path="/logistic/part_non_repairable/:id"
                    element={<LOGISTIC_PartNonRepairableShow />}
                  />
                  <Route
                    path="/logistic/part_non_repairable/:id/edit"
                    element={<LOGISTIC_PartNonRepairableEdit />}
                  />
                  <Route
                    path="/logistic/part_non_repairable/transfer"
                    element={<LOGISTIC_PartNonRepairableTransfer />}
                  />
                  <Route
                    path="/logistic/part_non_repairable/condition"
                    element={<LOGISTIC_PartNonRepairableCondition />}
                  />
                  {/* BTS0523: Stock Monitoring */}
                  <Route
                    path="/logistic/stock"
                    element={<LOGISTIC_StockMonitoring />}
                  />
                  {/* BTS0509/0510: Performance Analysis */}
                  <Route
                    path="/report/performance"
                    element={<REPORT_Performance />}
                  />
                  <Route
                    path="/repair-center/dashboard"
                    element={<RC_Dashboard />}
                  />
                  <Route path="/repair-center/rr/all" element={<RC_RRTAll />} />
                  <Route
                    path="/repair-center/rr/unclosed"
                    element={<RC_RRTUnclosed />}
                  />
                  <Route
                    path="/repair-center/rr/unclosed/:id"
                    element={<RC_RRTUnclosedDetail />}
                  />
                  <Route
                    path="/repair-center/rr/unclosed/:id/history"
                    element={<RC_RRTUnclosedHistory />}
                  />
                  <Route
                    path="/repair-center/rr/unclosed/:id/part-usage"
                    element={<RC_RRTUnclosedPartUsage />}
                  />
                  <Route
                    path="/repair-center/rr/unclosed/:id/stop-to-work"
                    element={<RC_RRTUnclosedStopToWork />}
                  />
                  <Route
                    path="/repair-center/rr/part-return"
                    element={<RC_RRTUnclosedDeliver />}
                  />
                  {/* BTS0513: RC Reporting page */}
                  <Route
                    path="/repair-center/report"
                    element={<RC_Report />}
                  />
                </Route>
              </Routes>
          </ErrorBoundary>
        </div>
      </BrowserRouter>
    </>
  );
}
